import { useMemo } from "react";
import { useCarConfigSelector } from "../redux/store";
import {
    VisualisationViewType,
    VisualisationModeType,
    type ExtraType,
} from "../../../../common-deprecated/types/CommonTypes";

type UseMobilityExtrasReturnType = {
    exteriorClaySupportedExtras: ExtraType[];
    interiorClaySupportedExtras: ExtraType[];
};

export const useAphMobilityExtras = (): UseMobilityExtrasReturnType => {
    const mobilitySolutionExtras = useCarConfigSelector((state) => [
        ...state.basket.extras.filter((extra) => {
            return extra.isMobilitySolution;
        }),
        ...state.basket.packExtras.filter((extra) => {
            return extra.isMobilitySolution;
        }),
        ...(state.basket.packs.flatMap((pack) =>
            pack.equipment.filter((equipment) => !equipment.isWheel && equipment.isMobilitySolution),
        ) as ExtraType[]),

        ...state.specs.standardEquipment.filter((extra) => {
            return extra.isMobilitySolution;
        }),
    ]);
    return useMemo(() => {
        return mobilitySolutionExtras.reduce(
            (acc: UseMobilityExtrasReturnType, extra: ExtraType) => {
                extra.visualisation.forEach(({ View, Mode }) => {
                    if (Mode === VisualisationModeType.Clay) {
                        if (View === VisualisationViewType.Exterior) acc.exteriorClaySupportedExtras.push(extra);
                        if (View === VisualisationViewType.Interior) acc.interiorClaySupportedExtras.push(extra);
                    }
                });
                return acc;
            },
            { interiorClaySupportedExtras: [], exteriorClaySupportedExtras: [] },
        );
    }, [mobilitySolutionExtras]);
};
